import React from 'react';
import { Typography } from '@forgeglobal/design-framework';
import Spinner from '@tcs/common/components/atoms/Spinner';
import { useStyles } from './style';

export interface HeaderProps {
  pageTitle?: string;
  children?: React.ReactNode;
  tabs?: () => JSX.Element;
  loading?: boolean;
}

export const Header = ({
  pageTitle,
  children,
  tabs: Tabs,
  loading,
}: HeaderProps) => {
  const classes = useStyles();

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className={classes.box}>
      <div className={classes.titleContainer} data-test-id="title-container">
        {pageTitle ? (
          <Typography variant="h4" data-test-id="title">
            {pageTitle}
          </Typography>
        ) : (
          children
        )}
      </div>
      {Tabs && <Tabs />}
    </div>
  );
};

export default Header;
